import { Params, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { BaseRouterStoreState, RouterStateSerializer } from '@ngrx/router-store';

export const FEATURE_NAME: string = 'router-feature';

export interface IRouterStateUrl extends BaseRouterStoreState {
  url: string;
  params: Params;
  queryParams: Params;
}

@Injectable()
export class CustomRouterStateSerializer implements RouterStateSerializer<IRouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): IRouterStateUrl {
    let route = routerState.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const {
      url,
      root: { queryParams },
    } = routerState;
    const { params } = route;

    return { url, params, queryParams };
  }
}
